import { Language } from './base';

const pdash = () => import('../translations/pdash/pt-PT.json');
const webActivities = () => import('../translations/web-activities/pt-PT.json');
const rdashTranslatables = () => import('../translations/rdash-translatables/pt-PT.json');

export default new Language({
    code: 'pt-PT',
    locale: 'pt',
    localName: 'Português',
    englishName: 'Portuguese',
    territory: 'PT',
    timezones: ['Europe/Lisbon'],
    notLoadedNamespaces: { pdash, webActivities, rdashTranslatables },
});
